// Components
import { FormField } from "@benchmark/ui/components/atomic";
import { FormGroup } from "@benchmark/ui/components/atomic";
import { FormSection } from "@benchmark/ui/components/atomic";
import { PhoneInput } from "@benchmark/ui/components/atomic";
import { TrimmedTextInput as TextInput } from "@benchmark/ui/components/atomic";

// Types
import type { UseFormReturnType } from "@mantine/form";
import type { PatientFormData } from "@benchmark/core/types";

/**
 * Props for EmergencyContactSection component.
 * @agentic @benchmark/core
 */
type EmergencyContactSectionProps = {
  form: UseFormReturnType<PatientFormData>;
};

/**
 * Form section for emergency contact (name and phone).
 * @agentic @benchmark/core
 */
export const EmergencyContactSection = ({
  form,
}: EmergencyContactSectionProps) => {
  return (
    <FormSection title="Emergency Contact">
      <FormGroup>
        <FormField label="First Name">
          <TextInput
            placeholder="Enter first name"
            autoComplete="off"
            {...form.getInputProps("emergency-contact-first-name")}
          />
        </FormField>
        <FormField label="Last Name">
          <TextInput
            placeholder="Enter last name"
            autoComplete="off"
            {...form.getInputProps("emergency-contact-last-name")}
          />
        </FormField>
        <FormField label="Phone">
          <PhoneInput
            placeholder="Enter phone number"
            autoComplete="off"
            {...form.getInputProps("emergency-contact-phone")}
          />
        </FormField>
      </FormGroup>
    </FormSection>
  );
};
